var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuiz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#5f6368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M540-378.46q12.38 0 21.81-9.42 9.42-9.43 9.42-21.81 0-12.39-9.42-21.81-9.43-9.42-21.81-9.42-12.38 0-21.81 9.42-9.42 9.42-9.42 21.81 0 12.38 9.42 21.81 9.43 9.42 21.81 9.42Zm-17.69-112.62h35.38q1.54-25.15 7.93-37.88 6.38-12.73 30.69-35.5 25.38-23.08 35.38-41.19 10-18.12 10-41.58 0-40.39-28.81-67.35-28.8-26.96-72.88-26.96-33.31 0-59.19 18-25.89 18-39.43 49.08l32.47 14.31q11.3-23.47 27.57-35.2 16.27-11.73 38.58-11.73 28.62 0 47.46 16.96 18.85 16.97 18.85 43.81 0 16.31-9.16 30.35-9.15 14.04-31.46 33.81-25.31 22.07-34.34 40.5-9.04 18.42-9.04 50.57ZM324.62-280q-27.62 0-46.12-18.5Q260-317 260-344.62v-430.76q0-27.62 18.5-46.12Q297-840 324.62-840h430.76q27.62 0 46.12 18.5Q820-803 820-775.38v430.76q0 27.62-18.5 46.12Q783-280 755.38-280H324.62Zm0-40h430.76q9.24 0 16.93-7.69 7.69-7.69 7.69-16.93v-430.76q0-9.24-7.69-16.93-7.69-7.69-16.93-7.69H324.62q-9.24 0-16.93 7.69-7.69 7.69-7.69 16.93v430.76q0 9.24 7.69 16.93 7.69 7.69 16.93 7.69Zm-120 160q-27.62 0-46.12-18.5Q140-197 140-224.61v-470.77h40v470.77q0 9.23 7.69 16.92 7.69 7.69 16.93 7.69h470.76v40H204.62ZM300-800v480-480Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuiz);
export default __webpack_public_path__ + "static/media/quiz.eba98df3cf1a6bcfdff7cbac8c36c72f.svg";
export { ForwardRef as ReactComponent };